export { default } from './MotionScrollWrapper';
